// extracted by mini-css-extract-plugin
export default {"expandButton":"vU3DbCQi"};